export default {
  'introThanks': 'Thank you for helping us improve by providing your feedback!',
  'customerFirstname': 'First name',
  'customerLastname': 'Last name',
  'customerEmail': 'E-mail',
  'customerTitle': 'Title',
  'visitFrom': 'Date of arrival',
  'visitTo': 'Date of departure',
  'visitRoom': 'Room number',
  'salutationOptionMr': 'Mr. ',
  'salutationOptionMrs': 'Ms. ',
  'salutationOptionFamily': 'Family',
  'btnStart': 'Start',
  'thanksTitle': 'Thank you!',
  'thanksTextFinish': 'Those in a hurry can now...',
  'thanksBtnFinish': 'Finish',
  'thanksTextContinue': '... the questionaire but if you still have a few minutes time, we would like to ask you a few more detailed questions.',
  'thanksBtnContinue': 'Further questions',
  'selectChooseOption': 'Please choose an option',
  'btnNext': 'Continue',
  'btnSkip': 'Skip',
  'btnFeedback': 'Comment',
  'selectorTextThanks': 'Great! Thanks for your help!',
  'selectorTextSelect': 'Which of the listed offers did you take advantage of?',
  'feedbackTitle': 'Your comment on this topic',
  'feedbackPositiveTitle': 'What was positive?',
  'feedbackNegativeTitle': 'What was negative?',
  'smileyVeryHappy': 'Very satisfied',
  'smileyHappy': 'Satisfied',
  'smileyMedium': 'OK',
  'smileyUnhappy': 'Unsatisfied',
  'smileyVeryUnhappy': 'Very unsatisfied',
  'smileyNotScored': 'Not rated',
  'validationMessageEmail': 'Please enter a valid e-mail address.',
  'validationMessageRequired': '"Mandatory field"',
  'txtAppStart': 'Load questionaire',
  'selectorTitle': 'Use of our offers',
  'finalThanksTitle': 'Thank you for your suggestions',
  'finalThanksHolidayCheckIntro': 'May we pass on part of your rating to HolidayCheck?<br />You would be doing us a big favor! On the next page we show you a summary of your data which we, with your permission, would transfer to HolidayCheck.<br /><br />It\'s just a few clicks & additions – then you\'re done.',
  'finalThanksHolidayCheckBtn': 'Show the HolidayCheck summary',
  'pickDate': 'Choose a date',
  'surveyFinishedTitle': 'Questionaire is finished',
  'surveyAlreadyDone': 'You have already participated in this survey, thank you!',
  'legendPrimerPositive': 'Completely satisfied',
  'legendPrimerNegative': 'Very unsatisfied',
  'hcTitle_recommendation': 'Would you recommend this hotel',
  'hcTitle_title': 'What is the title of your review?',
  'hcTitle_text': 'Describe the hotel in general.',
  'hcDescription_text': 'Describe your first impression of the hotel in 2-3 sentences. Was it suitable for your reason of travel, for example?',
  'hcFilledHint': 'Please fill out all the fields',
  'hcTitle_age': 'How old are you?',
  'hcTitle_traveledWith': 'With whom are you travelling?',
  'hcTitle_travelDuration': 'Length of stay',
  'hcOption_traveledWith_friends': 'Friends',
  'hcOption_traveledWith_family': 'Family',
  'hcOption_traveledWith_couple': 'Pair',
  'hcOption_traveledWith_single': 'Alone',
  'hcOption_children_no': 'none',
  'hcOption_children_one': '1',
  'hcOption_children_two': '2',
  'hcOption_children_three': '3',
  'hcOption_children_four': '4',
  'hcOption_children_more': 'more than 4',
  'hcOption_age_14-18': '16 - 18',
  'hcOption_age_19-25': '19 - 25',
  'hcOption_age_26-30': '26 - 30',
  'hcOption_age_31-35': '31 - 35',
  'hcOption_age_36-40': '36 - 40',
  'hcOption_age_41-45': '41 - 45',
  'hcOption_age_46-50': '46 - 50',
  'hcOption_age_51-55': '51 - 55',
  'hcOption_age_56-60': '56 - 60',
  'hcOption_age_61-65': '61 - 65',
  'hcOption_age_66-70': '66 - 70',
  'hcOption_age_70 >': '70+',
  'hcOption_ratingCostPerformance_poor': 'Very poor',
  'hcOption_ratingCostPerformance_bad': 'Rather poor',
  'hcOption_ratingCostPerformance_medium': 'Reasonable',
  'hcOption_ratingCostPerformance_good': 'Rather good',
  'hcOption_ratingCostPerformance_great': 'Very good',
  'hcOption_travelReason_business': 'Business',
  'hcOption_travelReason_city': 'City',
  'hcOption_travelReason_wellness': 'Spa',
  'hcOption_travelReason_winter': 'Winter',
  'hcOption_travelReason_other': 'Other',
  'hcOption_travelReason_beach': 'Beach',
  'hcOption_travelDuration_1-3 days': '1-3 days',
  'hcOption_travelDuration_3-5 days': '3-5 days',
  'hcOption_travelDuration_1 week': '1 week',
  'hcOption_travelDuration_2 weeks': '2 weeks',
  'hcOption_travelDuration_3 weeks': 'more than two weeks',
  'hcCardTitle': 'HolidayCheck rating transfer',
  'btnSubmit': 'Abschicken',
  'requiredField': 'Mandatory field',
  'hcPrivacyHint': 'Die Informationen zum Datenschutz gemäß Art. 13 und 14 DSGVO finden Sie hier <a href="https://www.holidaycheck.de/datenschutz" target="_blank">Link zum Datenschutz von HolidayCheck</a>.',
  'hcConsentHint': ' Ich erkläre mich damit einverstanden, dass meine angegebenen persönlichen Daten sowie die Bewertung zu HolidayCheck übertragen und veröffentlicht wird und akzeptiere die <a  target="_blank" href="https://www.holidaycheck.de/nutzungsbedingungen">Nutzungsbedingungen</a> von HolidayCheck',
  'topicTitle': 'Different topic?',
  'topicHint': 'Select the topic you want to comment on',
  'txtSuggestFeedback': 'Your comment would be great :-)',
  'txtFiguresPercent': 'Figures in percent',
  'txtImpress': 'Legal notice',
  'linkImpress': 'https://www.vioma.de/de/service/impressum/',
  'txtPrivacy': 'Privacy',
  'txtPrivacyConsent': 'I agree that my data from the survey will be collected and processed to improve the quality. The data will be deleted 24 months after the request. You may revoke your consent at any time by sending an email to <a href="mailto:%{mail}">%{mail}</a>. Detailed information on the handling of user data can be found in our <a href="%{link}" target="_blank">Privacy policy</a>.',
  'txtPrivacyHint': 'I agree that my summary will be published on the Company\'s website and on the review page at <a href="%{link}" target="_blank">%{link}</a> with my gender, abbreviated name, city and the date the conclusion was submitted. I can revoke this consent at any time at <a href="mailto:%{mail}">%{mail}</a> The published summary will then be deleted.',
  'txtExample': 'Example',
  'txtSkip': 'Skip',
  'txtPrivacyValidationHint': 'We cannot process the text without permission',
  'btnDifferentTopic': 'Different topic',
  'btnOK': 'OK'
}



// WEBPACK FOOTER //
// ./src/languages/en.js